import {
  ReauthenticationVariant,
  ResourceType,
  SvgIconComponent,
} from 'shared/types'
import { Board, Desk, Car } from 'shared/assets'
import { Locker } from 'shared/assets/globalworth'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import SpaIcon from '@mui/icons-material/Spa'

export const ResourceTypeIconMapping: Record<
  ResourceType,
  SvgIconComponent | typeof MoreHorizIcon
> = {
  [ResourceType.ConferenceRoom]: Board,
  [ResourceType.Desk]: Desk,
  [ResourceType.ParkingSpot]: Car,
  [ResourceType.Locker]: Locker,
  [ResourceType.Other]: MoreHorizIcon,
  [ResourceType.Sauna]: SpaIcon,
}

export const mapNumberToReauthenticationVariant = (
  value: number
): ReauthenticationVariant | null => {
  if (Object.values(ReauthenticationVariant).includes(value)) {
    return value as ReauthenticationVariant
  }
  return null
}
